<script>
    import _                from 'lodash'
    import validate         from 'validate.js'    
    import * as api         from '../../shared/api.js'
    import { Inventory }    from '../../shared/inventory.js'
    import Item             from '../../shared/Item.svelte'
    import Dropdown         from '../../shared/Dropdown.svelte'
    import Affected         from '../../shared/Affected.svelte'    
    import Info             from './Info.svelte'
    import Integration      from './Integration.svelte'
    import Fields           from './Fields.svelte'
    import Processors       from './Processors.svelte'
    import PlaceForm        from './PlaceForm.svelte'
    import PlaceCards       from './PlaceCards.svelte'

    export let inventory
    export let item
    export let domain 
    export let active
    export let latest
    export let disabled
    export let empty

    // let type     = null
    let affected = []     //activities affected by this place if removed

    $: actions = actionsGiven(item, inventory)

    const constraints = {
        name        : { presence: { allowEmpty: false, message: "campo obrigatório" } },
        responsible : { presence: { allowEmpty: false, message: "campo obrigatório" } },
        email       : { 
            presence : { allowEmpty: false, message: "campo obrigatório" }, 
            email    : {                    message: "email inválido"    } 
        }
    }

    function actionsGiven(item, inventory) {
        if(item.id == 0) return []
        const placeIssues = inventory.placeIssues(item)
        return [{
            id              : 'info',
            name            : 'Informações', 
            triggerLoading  : false,
            onClick         : () => { 
                return Promise.resolve(true)
            }
        },{
            id              : 'processors',
            name            : 'Operadores',
            triggerLoading  : false,
            onClick         : () => { 
                return Promise.resolve(true) 
            }
        },{
            id              : 'fields',
            name            : 'Dados',
            issues          : placeIssues, 
            triggerLoading  : false,
            onClick         : () => { 
                return Promise.resolve(true) 
            }
        },{
            id              : 'integration',
            name            : 'Integração', 
            triggerLoading  : false ,
            onClick         : () => { 
                return Promise.resolve(true)  
            }
        }]
    }

    function isDirty(item, copy) {
        return ! _.isEqual(item, copy)
    }
    
    function idOf(item) {
        return item.id
    }

    function onUpdate(it) {

        const fixDuration = field => {
            if(field.duration) {
                const duration = parseInt(field.duration)
                return {...field, duration }
            } else {
                return field
            }
        }

        it = _.omitBy(it, i => _.trim(i) === '')
        if(!it.kind /* legacy */) {
            it.kind = 'system'
        }

        it.fields = it.fields && it.fields.map(fixDuration) || []

        const method = it.id === 0 ? 'add' : 'update'
        const data   = it.id === 0 ? it    : { id: it.id, data: it }
        return api
            .post(`/inventory/domain/${domain.id}/${method}/place`, data)
            .then(api.toJsonIf200)
            .then(json => {
                inventory = new Inventory(json)
                active    = -1
                if(item.id === 0) {
                    item = empty()
                    // type = null  
                }
                return Promise.resolve(true)
            })
            .catch(err => {
                return Promise.reject("erro adicionando lugar")
            })
    }

    function forceRemove() {
        onRemove(item, true)
        affected  = []
    }

    function cancelRemove() {
        affected  = []
    }
    
    function onRemove(it, force) {
        return api
            .post(`/inventory/domain/${domain.id}/delete/place`, { id: it.id, force: !!force })
            .then(api.toJsonIf200)
            .then(json => {
                inventory = new Inventory(json)
                active    = -1
                return Promise.resolve(true)
            })
            .catch(res => {
                if (res.status === 406) {
                    res.json().then(json => affected  = json)
                } else {
                    return Promise.reject("erro removendo lugar")   
                }
            })
    }    
    
    function onCancel(evt) {
        // type = null
    }

    function validateItem(place) {
        const valid  = validate(place, constraints, { fullMessages: false }) || {}
        if(place && place.connector && place.connector.kind == 'gdrive-sheets') {
            if(place.fields.length == 0) {
                _.merge(valid, { fields: place.connector.kind }) /* disable the 'save' button if no fields are selected */
            }
        }
        return valid
    }

    function errorHandler(theAction, theItem, theError) {
        return {
            display : true,
            message : theError
        }
    }

    function iconGiven(item) {
        const connector = item.connectors.find(it => it.active)
        if(connector) {
            switch(connector.kind) {
                case "gdrive-sheets": return "google drive"
                case "api"          : return "exchange"
                case "email"        : return connector.anonymous ? "user secret" : "envelope outline"
                default             : return "circle outline"
            }
        } else {
            return "envelope outline"
        }
    }
</script>
<Item   
    resetOnToggle={true}
    debug={false} 
    bind:item 
    bind:active
    on:cancel={onCancel}
    {actions}
    {validateItem}
    {errorHandler}
    {idOf}
    {isDirty} 
    {disabled}
    {onUpdate}
    {onRemove}>
        <span slot="header">
            {#if item.id > 0}
                <div class="placeHeader">
                    <div>
                        <span class="name annotation-source" data-annotation={ JSON.stringify({ type: "place", name: item.name, target: item }) }>
                            {item.name}
                        </span>
                        {#if item.description}
                            <span class="description">
                                {item.description}
                            </span>
                        {/if}
                    </div>
                    <div class="icon">
                        {#if iconGiven(item)} 
                            <i class="ui grey disabled icon {iconGiven(item)}" ></i> 
                        {/if}
                    </div>
                </div>
            {/if}
        </span>
        <div slot="primary" let:display let:errors>
            {#if display}
                {#if item.id === 0}
                    <PlaceCards bind:item {inventory} {domain} {errors} {empty}></PlaceCards>
                {:else}
                    <PlaceForm bind:item {inventory} {errors}></PlaceForm>
                {/if}
            {/if}
        </div>    
        <div slot="secondary" let:display let:action={action}>
            {#if display && item.id === active}
                {#if action && "info" === action.id}
                    <div class="secondary info">
                        <Info place={item} {latest}/>
                    </div>
                {:else if action && "integration" === action.id}
                    <div class="secondary integration">
                        <Integration place={item} {domain} {latest}/>
                    </div>
                {:else if action && "fields" === action.id}
                    <div class="secondary fields">
                        <Fields place={item} {domain} {inventory} {latest} />
                    </div>
                {:else if action && "processors" === action.id}
                    <div class="secondary registry">
                        <Processors place={item} {domain} bind:inventory {latest} />
                    </div>
                {:else}
                    <div>NO ACTION</div>
                {/if}
            {/if}
        </div>
</Item>

{#if affected.length > 0}
    <Affected activities={affected} what="lugar" cancel={cancelRemove} confirm={forceRemove}></Affected>
{/if}


<style>

    .placeHeader {
        /* border: 1px solid red; */
        display: flex;
        flex-direction: row;
        margin-right: .5em;
    }

    .placeHeader > div:first-child {
        flex: 1;
        /* border: 1px solid red; */
    }

    .placeHeader .icon {
        align-self: flex-end;

    }

    .secondary {
        background-color: var(--main-bg-color);
        margin  : 20px 0 !important;
        padding : 30px !important;
        border-radius: 3px;
    }
</style>